<template>
  <c-box
    :title="'Структура поискового трафика за ' + date.format('MMM')"
    shadow
    header-divider
    :loading="loading"
  >
    <table
      v-if="!loading && data.length"
      class="table"
    >
      <thead>
        <tr>
          <th>Источник</th>
          <th>Визиты</th>
          <th>Просмотры</th>
          <th>Отказы</th>
          <th>Время на сайте</th>
        </tr>
      </thead>
      <thead>
        <tr class="active">
          <td colspan="5">
            <img
              :src="require('../../../../../../../resources/img/yandex.png')"
              class="sengine"
              alt="Yandex"
            >
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>ПК</td>
          <th>{{ getDataBySource('Яндекс. ПК').Визиты }}</th>
          <th>{{ getDataBySource('Яндекс. ПК').Просмотры }}</th>
          <th>{{ getDataBySource('Яндекс. ПК').Отказы }}%</th>
          <th>{{ getDataBySource('Яндекс. ПК').ВремяСтрока }}</th>
        </tr>
        <tr>
          <td>Мобильные</td>
          <th>{{ getDataBySource('Яндекс. Мобильные').Визиты }}</th>
          <th>{{ getDataBySource('Яндекс. Мобильные').Просмотры }}</th>
          <th>{{ getDataBySource('Яндекс. Мобильные').Отказы }}%</th>
          <th>{{ getDataBySource('Яндекс. Мобильные').ВремяСтрока }}</th>
        </tr>
      </tbody>
      <thead>
        <tr class="active">
          <td colspan="5">
            <img
              :src="require('../../../../../../../resources/img/google.png')"
              class="sengine"
              alt="Google"
            >
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>ПК</td>
          <th>{{ getDataBySource('Гугл. ПК').Визиты }}</th>
          <th>{{ getDataBySource('Гугл. ПК').Просмотры }}</th>
          <th>{{ getDataBySource('Гугл. ПК').Отказы }}%</th>
          <th>{{ getDataBySource('Гугл. ПК').ВремяСтрока }}</th>
        </tr>
        <tr>
          <td>Мобильные</td>
          <th>{{ getDataBySource('Гугл. Мобильные').Визиты }}</th>
          <th>{{ getDataBySource('Гугл. Мобильные').Просмотры }}</th>
          <th>{{ getDataBySource('Гугл. Мобильные').Отказы }}%</th>
          <th>{{ getDataBySource('Гугл. Мобильные').ВремяСтрока }}</th>
        </tr>
      </tbody>
      <thead>
        <tr class="active">
          <td colspan="5">
            Прочие (Mail.ru, Rambler, Yahoo, Bing и др.)
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Прочее</td>
          <th>{{ getDataBySource('Прочее').Визиты }}</th>
          <th>{{ getDataBySource('Прочее').Просмотры }}</th>
          <th>{{ getDataBySource('Прочее').Отказы }}</th>
          <th>{{ getDataBySource('Прочее').ВремяСтрока }}</th>
        </tr>
      </tbody>
    </table>
    <no-data v-if="!loading && !data.length" />
  </c-box>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import moment from 'moment'
import sengine from '../../../../../../../resources/js/mixins/sengine'
import NoData from '../../../../../../../resources/js/components/NoData.vue'

export default {
  name: 'TrafficStructure',
  components: { NoData, CBox },
  mixins: [sengine],
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    month: {
      type: Number,
      required: true
    }
  },
  computed: {
    date () {
      return moment().month(this.month)
    }
  },
  methods: {
    getDataBySource (source) {
      return this.data.find(value => value.ИсточникТрафика === source)
    }
  }
}
</script>

<style lang="scss" scoped>
img.sengine {
  padding-left: 10px;
}
</style>
